export default {
	chat: "Chat",
	do_you_confirm_your_registration_for_the_webinar: "Do you confirm your registration for the {title} webinar?",
	do_you_confirm_your_unsubscription_to_the_webinar: "Do you confirm your unsubscription to the {title} webinar?",
	external_link: "External link",
	join_webinar: "Join Webinar",
	live: "Live",
	loading_webinars: "Loading webinars",
	next: "Next",
	no_webinars_are_available_at_the_moment: "There are currently no webinars available",
	no_webinars_are_available_with_the_selected_filter: "There are no webinars available for the selected filter",
	receive_emails_about_this_webinar: "Receive emails about this webinar",
	register_for_the_webinar: "Register for the webinar",
	subscribe: "Subscribe",
	subscribed: "Subscribed",
	successfully_signed_up_for_the_webinar: "Successfully signed up for the webinar",
	training_available_at: "Training available at",
	transmission_date: "Transmission Date",
	transmission_finished: "Transmission Finished",
	unsubscribe_from_the_webinar: "Unsubscribe from the webinar",
	unsubscribe_successfully_for_the_webinar: "Unsubscribe successfully for the webinar",
	unsubscribe: "Unsubscribe",
	watch: "Watch",
	webinar_offline: "Webinar offline",
	write_your_question: "Write your question",
	your_message_has_been_received_and_is_awaiting_moderation: "Your message has been received and is awaiting moderation",
	your_message_has_been_received: "Your message has been received",
	your_webinar_will_start_soon_please_wait: "Your webinar will start soon, please wait"
}